import React from 'react'
import { getDiscipline, getOrdini } from 'utils'

const Pills = React.memo(({ tassonomia = [], classes = '' }) => {
  let ordini = getOrdini(tassonomia)
  let discipline = getDiscipline(tassonomia)

  const pills = ordini
    .concat(discipline)
    .filter(item => item)
    .map(item => (
      <span className="pills__item" key={item}>
        {item}
      </span>
    ))

  return pills.length ? <div className={`${classes} pills`}>{pills}</div> : null
})

export default Pills
